import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WorkshopDefectsComponent } from './pages/workshop-defects/workshop-defects.component';
import { WorkshopDefectsNewComponent } from './pages/workshop-defects-new/workshop-defects-new.component';
import { WorkshopDefectsEditComponent } from './pages/workshop-defects-edit/workshop-defects-edit.component';
import { WorkshopTimelineComponent } from './pages/workshop-timeline/workshop-timeline.component';
import { WorkshopInvoicingComponent } from './pages/workshop-invoicing/workshop-invoicing.component';
import { AuthGuard } from '../auth/guards/auth.guard';

const routes: Routes = [
  {
    path: 'workshop/defects',
    component: WorkshopDefectsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'workshop/timeline',
    component: WorkshopTimelineComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'workshop/invoicing',
    component: WorkshopInvoicingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'workshop/defects/new',
    component: WorkshopDefectsNewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'workshop/defects/edit/:id',
    component: WorkshopDefectsEditComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WorkshopDefectsRoutingModule { }
